//==============================================================================
/**
 * Message strings for parent/child communication
 * @type {object} pseudo-constant
 */
const GyroMessages =
  {
    // posted by child, received by parent
    HANDSHAKE   : "gyro-handshake",
    ENABLE      : "gyro-enable",
    DISABLE     : "gyro-disable",

    // posted by parent, received by child
    HANDSHOOK   : "gyro-handshook",
    ENABLED     : "gyro-enabled",
    DISABLED    : "gyro-disabled",
    MOTION      : "gyro-motion",
    ERROR       : "gyro-error"
  };

export { GyroMessages };